import { ReactNode } from "react";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

interface TabPanelProps {
  children?: ReactNode;
  value: number;
  index: number;
}

export const TabPanel = ({ children, value, index }: TabPanelProps) => (
    <StyledTabPanel
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <StyledBox>{children}</StyledBox>}
    </StyledTabPanel>
  );

const StyledTabPanel = styled.div`
  // border-top: 2px solid #1976d2;
`;

const StyledBox = styled(Box)`
  background: #ffffff;
  width: 100%;
  height: 100%;
`;
